
























































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { PartCatalogueAssemblyItemDetail } from '@/entities/part-catalogue/PartCatalogueAssemblyItemDetail';
import { PartCatalogueDetailsItemMeta } from '@/components/part-catalogue/PartCatalogueDetailsItemMeta';
import Price from '@/components/price/Price.vue';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import { localize } from '@/filters/localize';
import { localizeWithFallbackKey } from '@/filters/localizeWithFallbackKey';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import _, { partition } from 'lodash';
import { PartService } from '@/services/part-service';

@Component({
    components: {
        Price,
        ShoppingCartActions,
        PartCatalogueDetailsItemMeta,
        DeliveryTimeToolTip,
        LoadingIndicator,
    },
})
export default class PartCatalogueSelector extends Mixins(BaseMixin) {
    private readonly partService: PartService = new PartService();

    @Prop({ type: Object, required: true })
    private readonly itemDetail!: PartCatalogueAssemblyItemDetail;

    @Prop()
    private readonly representsHotspotIds!: string[];

    @Prop()
    private readonly linkToItem!: string;

    private reloadAvailabilityDebounced: (quantity: number) => void;

    constructor() {
        super();
        this.reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
    }

    public get positionInAssembly(): string {
        return this.itemDetail.item.positionInAssembly;
    }

    public get maxQuantityToOrder(): number | undefined {
        if (!this.itemDetail.isUsedPart) {
            return undefined;
        }

        return this.itemDetail.availability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }

    public get getDefaultQuantity(): number {
        const quantity = this.itemDetail.item && Number(this.itemDetail.item.quantity);
        if (this.maxQuantityToOrder === undefined) {
            return quantity;
        }
        return quantity <= this.maxQuantityToOrder ? quantity : this.maxQuantityToOrder;
    }

    public representsHotspot(hotspotId: string): boolean {
        return this.representsHotspotIds.includes(hotspotId);
    }

    private get availability(): string | undefined {
        if (this.itemDetail.availability == null) {
            return localize(this.l10n.AVAILABILITY.NOT_IN_STOCK);
        }
        return localizeWithFallbackKey(
            this.l10n.AVAILABILITY.For(this.itemDetail.availability.code),
            this.l10n.AVAILABILITY.UNKNOWN
        );
    }

    private get partExists(): boolean {
        return this.itemDetail.price != null && this.itemDetail.availability != null && this.itemDetail.part != null;
    }

    private quantityChanged(quantity: number): void {
        this.reloadAvailabilityDebounced(quantity);
    }

    private reloadAvailability(quantity: number): void {
        const partId = this.itemDetail.part.id;
        this.itemDetail.isAvailabilityLoading = true;
        this.partService.getAvailabilityOfPart(partId, quantity).then((availability) => {
            if (availability) {
                this.itemDetail.availability = availability;
            }
            this.itemDetail.isAvailabilityLoading = false;
        });
    }
}
